// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + ".app." + {"85":"307accc2","473":"06521829","945":"8ebac109"}[chunkId] + ".js";
};